import { render, staticRenderFns } from "./bobselect.vue?vue&type=template&id=53c316c7&scoped=true"
import script from "./bobselect.vue?vue&type=script&lang=js"
export * from "./bobselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c316c7",
  null
  
)

export default component.exports